type Options = {
  expires?: Date|number|string,
  path?: string,
  domain?: string,
  secure?: boolean,
  'max-age'?: number,
}

export function getCookie(name: string) {
  // eslint-disable-next-line no-useless-escape
  const regExp = /([\.$?*|{}\(\)\[\]\\\/\+^])/g;
  const matches = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(regExp, '\\$1') + '=([^;]*)')
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

// Example of use:
// setCookie('user', 'John', {secure: true, 'max-age': 3600});
function setCookie(name: string, value: string, options: Options) {

  options = {
    path: '/',
    // add other defaults here if necessary
    ...options
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  let optionKey: keyof Options;
  for (optionKey in options) {
    updatedCookie += "; " + optionKey;
    const optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

export function deleteCookie(name: string, options: Options ) {
  setCookie(name, "", {
    ...options,
    'max-age': -1
  })
}